var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<i class=\"ct-loader-button-spinner fa fa-refresh fa-spin fa-3x fa-fw\"></i>";
ngModule.run(["$templateCache",function(c){c.put("components/component-spinner-button/spinner.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/component-spinner-button/spinner.html
 ** module id = 548
 ** module chunks = 1
 **/